import React, { useEffect, useState } from 'react';
import { Button, Col, Row, Typography } from 'antd';
import '../CSSfiles/YourTableComponent.css';
import { useAppContext } from './AppContext';

const { Text } = Typography;

const YourTableComponent = () => {

  const { tableData,filteredTableData } = useAppContext();
  const {reportType, setReportType,upName} = useAppContext();
  const [StretchCount, setStretchCount] = React.useState(0);
  const [DevelopCount, setDevelopCount] = React.useState(0);
  const [ObserveCount, setObserveCount] = React.useState(0);
  const [TotalCount, setTotalCount] = React.useState(0);
  const [Stretchpercentage, setStretchpercentage] = React.useState(0);
  const [Developpercentage, setDeveloppercentage] = React.useState(0);
  const [Observepercentage, setObservepercentage] = React.useState(0);
  const { filterTableDataBySummary } = useAppContext();

  const dataSource = [
    { key: '1', col1: 'Top Talent', col2: StretchCount, col3: Stretchpercentage + '%' },
    { key: '2', col1: 'Consistent', col2: DevelopCount, col3: Developpercentage + '%' },
    { key: '3', col1: 'Observe', col2: ObserveCount, col3: Observepercentage + '%' },
    { key: '4', col1: 'Total', col2: TotalCount, col3: '100.00%' },
  ];

  const columns = [
    { dataIndex: 'col1', key: 'col1', render: (text, record) => <strong>{text}</strong>, },
    { title: <strong>Head Count</strong>, dataIndex: 'col2', key: 'col2', align: 'center' },
    { title: <strong>Head Count %</strong>, dataIndex: 'col3', key: 'col3', align: 'center' },
  ];

  const rowClassName = (record, index) => {
    if (index == 0) {
      return 'row-1'
    }
    else if (index == 1) {
      return 'row-2'
    }
    else if (index == 2) {
      return 'row-3'
    }
  };

  const columnClassName = (col, index) => {
    return index === 0 ? 'highlight-column' : '';
  };



  useEffect(() => {
    //console.log('upName:', upName)
    //console.log('reportType:', reportType)

    let filteredResults = tableData;

    //console.log('filteredResults:', filteredResults)
   
    if (reportType === 'Direct Reports') {
       filteredResults = tableData.filter(item => {
        return (
          item.managerEmail && item.managerEmail.toString().toLowerCase() === upName.toString().toLowerCase()
        );
      });
    }
    else if (reportType === 'Indirect Reports') {
       filteredResults = tableData.filter(item => {
        return (
          item.managerEmail && item.managerEmail.toString().toLowerCase() !== upName.toString().toLowerCase()
        );
      });
    }
    else {
      filteredResults = tableData;
    }
    //console.log('tableData:', tableData)  
    //console.log('filteredResults:', filteredResults)
    const Stretch = filteredResults.filter((item) => (item.nineboxmapping === 'Top Talent') || (item.nineboxmapping === 'Promotable') || (item.nineboxmapping === 'Expandable'));
    setStretchCount(Stretch.length);
    const Develop = filteredResults.filter((item) => (item.nineboxmapping === 'Solid Performer') || (item.nineboxmapping === 'Suitably Placed') || (item.nineboxmapping === '"Valued Professional'));
    setDevelopCount(Develop.length);
    const Observe = filteredResults.filter((item) => (item.nineboxmapping === 'Poor Fit') || (item.nineboxmapping === 'Needs Improvement') || (item.nineboxmapping === 'Needs Performance Management'));
    setObserveCount(Observe.length);
    setTotalCount(filteredResults.length);
    setStretchpercentage(((Stretch.length / filteredResults.length) * 100).toFixed(2));
    setDeveloppercentage(((Develop.length / filteredResults.length) * 100).toFixed(2));
    setObservepercentage(((Observe.length / filteredResults.length) * 100).toFixed(2));
  }, [upName,reportType,tableData]);

  const buttonStyle = {
    width: '140px', // Adjust the width
    height: '100px', // Adjust the height
    borderRadius: '10px', // Adjust the border-radius for curved edges
    marginBottom: '3px', // Adjust spacing between buttons
  };

  const handleButtonClick = (text) => {
    // Handle button click
    //console.log(`Button clicked: ${text}`);
    filterTableDataBySummary(text);
  };

  return (
    <div>
      <Row gutter={[16, 16]}>
        <Col span={8}><Button onClick={() => handleButtonClick('Top Talent')} style={{ ...buttonStyle, border: `1px solid #008000`, backgroundColor: '#DCF3D9' }}>
        <div style={{ textAlign: 'center' }}> 
          <Text style={{ fontSize: '14px', color: '#008000', fontWeight: 'bold' }}>Top Talent</Text>
          <br />
          <Text style={{ fontSize: '35px', color: '#008000', fontWeight: 'bold' }}>{StretchCount}</Text>
          <Text style={{ fontSize: '14px', color: '#008000', marginLeft: 5 }}>{Stretchpercentage}%</Text>
          <br />
          </div>
        </Button></Col>
        <Col span={8}><Button onClick={() => handleButtonClick('Consistent')} style={{ ...buttonStyle, border: `1px solid #D68910`, backgroundColor: '#FCF3CF' }}>
        <div style={{ textAlign: 'center' }}> 
          <Text style={{ fontSize: '14px', color: '#D68910', fontWeight: 'bold' }}>Consistent</Text>
          <br />
          <Text style={{ fontSize: '35px', color: '#D68910', fontWeight: 'bold' }}>{DevelopCount}</Text>
          <Text style={{ fontSize: '14px', color: '#D68910', marginLeft: 5 }}>{Developpercentage}%</Text>
          <br />
          </div>
        </Button></Col>
        <Col span={8}><Button onClick={() => handleButtonClick('Observe')} style={{ ...buttonStyle, border: `1px solid #FF3131`, backgroundColor: '#F9ECEC' }}>
        <div style={{ textAlign: 'center' }}> 
          <Text style={{ fontSize: '14px', color: '#FF3131', fontWeight: 'bold' }}>Observe</Text>
          <br />
          <Text style={{ fontSize: '35px', color: '#FF3131', fontWeight: 'bold' }}>{ObserveCount}</Text>
          <Text style={{ fontSize: '14px', color: '#FF3131', marginLeft: 5 }}>{Observepercentage}%</Text>
          <br />
          </div>
        </Button></Col>
      </Row>
    </div>    
  );
};

export default YourTableComponent;
